(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuralea-about"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nuralea-about')) {
    customElements.define('nuralea-about', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.items = [];
        this.observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const item = this.items.find(candidate => candidate.wrapper === entry.target);
            if (item) { item.visible = entry.isIntersecting; this.updatePlayback(item); }
          });
        }, { threshold: 0.15 }) : null;
        this.querySelectorAll('[data-about-video]').forEach(wrapper => {
          const video = wrapper.querySelector('video');
          const button = wrapper.querySelector('[data-video-toggle]');
          if (!video || !button) return;
          const item = { wrapper, video, button, visible: !this.observer, intent: null };
          this.items.push(item);
          video.muted = true;
          video.defaultMuted = true;
          video.controls = false;
          video.setAttribute('playsinline', '');
          button.hidden = false;
          const sync = () => {
            button.querySelector('[data-video-label]').textContent = video.paused ? button.dataset.labelPlay : button.dataset.labelPause;
            button.querySelector('[data-icon-play]').toggleAttribute('hidden', !video.paused);
            button.querySelector('[data-icon-pause]').toggleAttribute('hidden', video.paused);
          };
          video.addEventListener('play', sync, { signal: this.abort.signal });
          video.addEventListener('pause', sync, { signal: this.abort.signal });
          video.addEventListener('volumechange', () => { if (!video.muted) video.muted = true; }, { signal: this.abort.signal });
          button.addEventListener('click', () => {
            item.intent = video.paused ? 'play' : 'pause';
            this.updatePlayback(item);
          }, { signal: this.abort.signal });
          sync();
          if (this.observer) this.observer.observe(wrapper);
          else this.updatePlayback(item);
        });
        document.addEventListener('visibilitychange', () => this.items.forEach(item => this.updatePlayback(item)), { signal: this.abort.signal });
        this.motion.addEventListener('change', () => {
          this.items.forEach(item => { item.intent = null; this.updatePlayback(item); });
          if (this.motion.matches && this.revealObserver) {
            this.revealObserver.disconnect();
            this.revealAnimations.forEach(animation => animation.cancel());
          }
        }, { signal: this.abort.signal });
        this.setupNavigation();
        this.setupReveals();
      }
      setupNavigation() {
        this.nav = this.querySelector('[data-about-nav]');
        if (!this.nav) return;
        this.links = Array.from(this.nav.querySelectorAll('[data-about-link]')).map(link => ({ link, target: document.getElementById(link.getAttribute('href').slice(1)) })).filter(item => item.target && this.contains(item.target));
        this.headers = Array.from(document.querySelectorAll('header, sticky-header, .shopify-section-group-header-group')).filter(header => !this.contains(header));
        const schedule = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.syncNavigation(); });
        };
        this.links.forEach(({ link, target }) => link.addEventListener('click', event => {
          if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.syncNavigation();
          target.scrollIntoView({ behavior: this.motion.matches ? 'instant' : 'smooth', block: 'start' });
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          try { history.replaceState(null, '', link.hash); } catch (_) {}
        }, { signal: this.abort.signal }));
        window.addEventListener('scroll', schedule, { passive: true, signal: this.abort.signal });
        window.addEventListener('resize', schedule, { passive: true, signal: this.abort.signal });
        schedule();
      }
      syncNavigation() {
        if (!this.nav) return;
        const base = parseFloat(getComputedStyle(this).getPropertyValue('--na-nav-offset')) || 0;
        let headerBottom = 0;
        this.headers.forEach(header => {
          const position = getComputedStyle(header).position;
          const box = header.getBoundingClientRect();
          if ((position === 'fixed' || position === 'sticky') && box.top <= 20 && box.bottom > 0 && box.height < innerHeight / 2) headerBottom = Math.max(headerBottom, box.bottom);
        });
        this.style.setProperty('--na-header-offset', Math.max(base, headerBottom + (headerBottom ? 12 : 0)) + 'px');
        this.style.setProperty('--na-nav-height', this.nav.offsetHeight + 'px');
        const line = this.nav.getBoundingClientRect().bottom + 48;
        let active = this.links[0];
        this.links.forEach(item => { if (item.target.getBoundingClientRect().top <= line) active = item; });
        this.links.forEach(item => {
          if (item === active) item.link.setAttribute('aria-current', 'location');
          else item.link.removeAttribute('aria-current');
        });
        if (active && this.activeLink !== active.link) {
          this.activeLink = active.link;
          const rail = this.nav.querySelector('.na-about__nav-links');
          const itemBox = active.link.getBoundingClientRect();
          const railBox = rail.getBoundingClientRect();
          if (itemBox.left < railBox.left || itemBox.right > railBox.right) rail.scrollTo({ left: rail.scrollLeft + itemBox.left - railBox.left - (rail.clientWidth - itemBox.width) / 2, behavior: this.motion.matches ? 'instant' : 'smooth' });
        }
      }
      setupReveals() {
        this.revealAnimations = [];
        if (this.motion.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
        this.revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.revealObserver.unobserve(entry.target);
          this.revealAnimations.push(entry.target.animate([{ opacity: .65, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 500, easing: 'cubic-bezier(.2,.65,.3,1)' }));
        }), { threshold: .1 });
        this.querySelectorAll('.na-about__statement, .na-about__story-copy, .na-about__value, .na-about__closing').forEach(element => this.revealObserver.observe(element));
      }
      updatePlayback(item) {
        const shouldPlay = item.visible && !document.hidden && item.intent !== 'pause' && (!this.motion.matches || item.intent === 'play');
        if (shouldPlay) {
          item.video.muted = true;
          const result = item.video.play();
          if (result) result.catch(() => {});
        } else item.video.pause();
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.revealObserver) this.revealObserver.disconnect();
        if (this.revealAnimations) this.revealAnimations.forEach(animation => animation.cancel());
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = null;
        this.activeLink = null;
        if (this.items) this.items.forEach(item => item.video.pause());
        if (this.abort) this.abort.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuralea-bestseller-produkte"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selectSwatch = (swatch) => {
      if (swatch.disabled) {
        return;
      }

      const card = swatch.closest('[data-product-card]');

      if (!card) {
        return;
      }

      card.querySelectorAll('[data-product-swatch]').forEach((item) => {
        const selected = item === swatch;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      if (swatch.dataset.variantUrl) {
        card.querySelectorAll('[data-product-link]').forEach((link) => {
          link.href = swatch.dataset.variantUrl;
        });
      }

      const currentPrice = card.querySelector('[data-current-price]');
      const comparePrice = card.querySelector('[data-compare-price]');
      const saveBadge = card.querySelector('[data-save-badge]');
      const saveValue = card.querySelector('[data-save-value]');
      const isSale = Boolean(swatch.dataset.comparePrice);

      if (currentPrice && swatch.dataset.price) {
        currentPrice.textContent = swatch.dataset.price;
        currentPrice.classList.toggle('is-sale', isSale);
      }

      if (comparePrice) {
        comparePrice.textContent = swatch.dataset.comparePrice || '';
        comparePrice.hidden = !isSale;
      }

      if (saveBadge && saveValue) {
        saveValue.textContent = swatch.dataset.saveValue || '';
        saveBadge.hidden = !swatch.dataset.saveValue;
      }

      if (swatch.dataset.imageSrc) {
        const image = card.querySelector('.nuralea-product-card__image');

        if (image) {
          image.src = swatch.dataset.imageSrc;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.alt = swatch.dataset.imageAlt || image.alt;
        }
      }
    };

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setupProgressiveGrid = (root) => {
      const cards = Array.from(root.querySelectorAll('[data-product-card]'));
      const action = root.querySelector('[data-product-grid-action]');
      const productList = root.querySelector('.nuralea-product-grid__products');

      if (!action || !productList || cards.length === 0) {
        return null;
      }

      const initialMobile = Number.parseInt(root.dataset.initialMobile, 10) || 4;
      const initialDesktop = Number.parseInt(root.dataset.initialDesktop, 10) || 8;
      const productsPerClick = Number.parseInt(root.dataset.productsPerClick, 10) || 4;
      const label = action.querySelector('[data-product-grid-action-label]');
      let visibleCount = Math.min(cards.length, mobileQuery.matches ? initialMobile : initialDesktop);

      action.setAttribute('aria-controls', productList.id);

      const update = (animateFrom) => {
        cards.forEach((card, index) => {
          const shouldHide = index >= visibleCount;
          const shouldAnimate = !shouldHide && index >= animateFrom;
          card.hidden = shouldHide;

          if (shouldAnimate && !reducedMotionQuery.matches) {
            card.classList.remove('is-revealing');
            card.getBoundingClientRect();
            card.classList.add('is-revealing');
            window.setTimeout(() => card.classList.remove('is-revealing'), 500);
          }
        });

        const hasMoreProducts = visibleCount < cards.length;
        action.dataset.actionMode = hasMoreProducts ? 'load-more' : 'view-all';
        action.setAttribute('aria-expanded', hasMoreProducts ? 'false' : 'true');

        if (label) {
          label.textContent = hasMoreProducts
            ? action.dataset.loadMoreLabel
            : action.dataset.viewAllLabel;
        }
      };

      const handleAction = (event) => {
        if (visibleCount >= cards.length) {
          return;
        }

        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }

        event.preventDefault();
        const previousCount = visibleCount;
        visibleCount = Math.min(cards.length, visibleCount + productsPerClick);
        update(previousCount);
      };

      const handleBreakpoint = () => {
        const viewportInitial = mobileQuery.matches ? initialMobile : initialDesktop;
        visibleCount = Math.min(cards.length, Math.max(visibleCount, viewportInitial));
        update(Number.POSITIVE_INFINITY);
      };

      action.addEventListener('click', handleAction);
      mobileQuery.addEventListener('change', handleBreakpoint);
      update(Number.POSITIVE_INFINITY);

      return () => {
        action.removeEventListener('click', handleAction);
        mobileQuery.removeEventListener('change', handleBreakpoint);
      };
    };

    const init = (root) => {
      if (root.dataset.productGridReady === 'true') {
        return;
      }

      root.dataset.productGridReady = 'true';
      root.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-product-swatch]');

        if (swatch && root.contains(swatch)) {
          selectSwatch(swatch);
        }
      });
      root.productGridCleanup = setupProgressiveGrid(root);
    };

    const initAll = () => {
      document.querySelectorAll('[data-nuralea-product-grid]').forEach(init);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-nuralea-product-grid]')
        ? event.target
        : event.target.querySelector('[data-nuralea-product-grid]');

      if (root) {
        init(root);
      }
    });
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches('[data-nuralea-product-grid]')
        ? event.target
        : event.target.querySelector('[data-nuralea-product-grid]');

      if (root && root.productGridCleanup) {
        root.productGridCleanup();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuralea-bracelets"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selectSwatch = (swatch) => {
      if (swatch.disabled) {
        return;
      }

      const card = swatch.closest('[data-product-card]');

      if (!card) {
        return;
      }

      card.querySelectorAll('[data-product-swatch]').forEach((item) => {
        const selected = item === swatch;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      if (swatch.dataset.variantUrl) {
        card.querySelectorAll('[data-product-link]').forEach((link) => {
          link.href = swatch.dataset.variantUrl;
        });
      }

      const currentPrice = card.querySelector('[data-current-price]');
      const comparePrice = card.querySelector('[data-compare-price]');
      const saveBadge = card.querySelector('[data-save-badge]');
      const saveValue = card.querySelector('[data-save-value]');
      const isSale = Boolean(swatch.dataset.comparePrice);

      if (currentPrice && swatch.dataset.price) {
        currentPrice.textContent = swatch.dataset.price;
        currentPrice.classList.toggle('is-sale', isSale);
      }

      if (comparePrice) {
        comparePrice.textContent = swatch.dataset.comparePrice || '';
        comparePrice.hidden = !isSale;
      }

      if (saveBadge && saveValue) {
        saveValue.textContent = swatch.dataset.saveValue || '';
        saveBadge.hidden = !swatch.dataset.saveValue;
      }

      if (swatch.dataset.imageSrc) {
        const image = card.querySelector('.nuralea-product-card__image');

        if (image) {
          image.src = swatch.dataset.imageSrc;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.alt = swatch.dataset.imageAlt || image.alt;
        }
      }
    };

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setupProgressiveGrid = (root) => {
      const cards = Array.from(root.querySelectorAll('[data-product-card]'));
      const action = root.querySelector('[data-product-grid-action]');
      const productList = root.querySelector('.nuralea-product-grid__products');

      if (!action || !productList || cards.length === 0) {
        return null;
      }

      const initialMobile = Number.parseInt(root.dataset.initialMobile, 10) || 4;
      const initialDesktop = Number.parseInt(root.dataset.initialDesktop, 10) || 8;
      const productsPerClick = Number.parseInt(root.dataset.productsPerClick, 10) || 4;
      const label = action.querySelector('[data-product-grid-action-label]');
      let visibleCount = Math.min(cards.length, mobileQuery.matches ? initialMobile : initialDesktop);

      action.setAttribute('aria-controls', productList.id);

      const update = (animateFrom) => {
        cards.forEach((card, index) => {
          const shouldHide = index >= visibleCount;
          const shouldAnimate = !shouldHide && index >= animateFrom;
          card.hidden = shouldHide;

          if (shouldAnimate && !reducedMotionQuery.matches) {
            card.classList.remove('is-revealing');
            card.getBoundingClientRect();
            card.classList.add('is-revealing');
            window.setTimeout(() => card.classList.remove('is-revealing'), 500);
          }
        });

        const hasMoreProducts = visibleCount < cards.length;
        action.dataset.actionMode = hasMoreProducts ? 'load-more' : 'view-all';
        action.setAttribute('aria-expanded', hasMoreProducts ? 'false' : 'true');

        if (label) {
          label.textContent = hasMoreProducts
            ? action.dataset.loadMoreLabel
            : action.dataset.viewAllLabel;
        }
      };

      const handleAction = (event) => {
        if (visibleCount >= cards.length) {
          return;
        }

        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }

        event.preventDefault();
        const previousCount = visibleCount;
        visibleCount = Math.min(cards.length, visibleCount + productsPerClick);
        update(previousCount);
      };

      const handleBreakpoint = () => {
        const viewportInitial = mobileQuery.matches ? initialMobile : initialDesktop;
        visibleCount = Math.min(cards.length, Math.max(visibleCount, viewportInitial));
        update(Number.POSITIVE_INFINITY);
      };

      action.addEventListener('click', handleAction);
      mobileQuery.addEventListener('change', handleBreakpoint);
      update(Number.POSITIVE_INFINITY);

      return () => {
        action.removeEventListener('click', handleAction);
        mobileQuery.removeEventListener('change', handleBreakpoint);
      };
    };

    const init = (root) => {
      if (root.dataset.productGridReady === 'true') {
        return;
      }

      root.dataset.productGridReady = 'true';
      root.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-product-swatch]');

        if (swatch && root.contains(swatch)) {
          selectSwatch(swatch);
        }
      });
      root.productGridCleanup = setupProgressiveGrid(root);
    };

    const initAll = () => {
      document.querySelectorAll('[data-nuralea-product-grid]').forEach(init);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-nuralea-product-grid]')
        ? event.target
        : event.target.querySelector('[data-nuralea-product-grid]');

      if (root) {
        init(root);
      }
    });
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches('[data-nuralea-product-grid]')
        ? event.target
        : event.target.querySelector('[data-nuralea-product-grid]');

      if (root && root.productGridCleanup) {
        root.productGridCleanup();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuralea-earrings"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selectSwatch = (swatch) => {
      if (swatch.disabled) {
        return;
      }

      const card = swatch.closest('[data-product-card]');

      if (!card) {
        return;
      }

      card.querySelectorAll('[data-product-swatch]').forEach((item) => {
        const selected = item === swatch;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      if (swatch.dataset.variantUrl) {
        card.querySelectorAll('[data-product-link]').forEach((link) => {
          link.href = swatch.dataset.variantUrl;
        });
      }

      const currentPrice = card.querySelector('[data-current-price]');
      const comparePrice = card.querySelector('[data-compare-price]');
      const saveBadge = card.querySelector('[data-save-badge]');
      const saveValue = card.querySelector('[data-save-value]');
      const isSale = Boolean(swatch.dataset.comparePrice);

      if (currentPrice && swatch.dataset.price) {
        currentPrice.textContent = swatch.dataset.price;
        currentPrice.classList.toggle('is-sale', isSale);
      }

      if (comparePrice) {
        comparePrice.textContent = swatch.dataset.comparePrice || '';
        comparePrice.hidden = !isSale;
      }

      if (saveBadge && saveValue) {
        saveValue.textContent = swatch.dataset.saveValue || '';
        saveBadge.hidden = !swatch.dataset.saveValue;
      }

      if (swatch.dataset.imageSrc) {
        const image = card.querySelector('.nuralea-product-card__image');

        if (image) {
          image.src = swatch.dataset.imageSrc;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.alt = swatch.dataset.imageAlt || image.alt;
        }
      }
    };

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setupProgressiveGrid = (root) => {
      const cards = Array.from(root.querySelectorAll('[data-product-card]'));
      const action = root.querySelector('[data-product-grid-action]');
      const productList = root.querySelector('.nuralea-product-grid__products');

      if (!action || !productList || cards.length === 0) {
        return null;
      }

      const initialMobile = Number.parseInt(root.dataset.initialMobile, 10) || 4;
      const initialDesktop = Number.parseInt(root.dataset.initialDesktop, 10) || 8;
      const productsPerClick = Number.parseInt(root.dataset.productsPerClick, 10) || 4;
      const label = action.querySelector('[data-product-grid-action-label]');
      let visibleCount = Math.min(cards.length, mobileQuery.matches ? initialMobile : initialDesktop);

      action.setAttribute('aria-controls', productList.id);

      const update = (animateFrom) => {
        cards.forEach((card, index) => {
          const shouldHide = index >= visibleCount;
          const shouldAnimate = !shouldHide && index >= animateFrom;
          card.hidden = shouldHide;

          if (shouldAnimate && !reducedMotionQuery.matches) {
            card.classList.remove('is-revealing');
            card.getBoundingClientRect();
            card.classList.add('is-revealing');
            window.setTimeout(() => card.classList.remove('is-revealing'), 500);
          }
        });

        const hasMoreProducts = visibleCount < cards.length;
        action.dataset.actionMode = hasMoreProducts ? 'load-more' : 'view-all';
        action.setAttribute('aria-expanded', hasMoreProducts ? 'false' : 'true');

        if (label) {
          label.textContent = hasMoreProducts
            ? action.dataset.loadMoreLabel
            : action.dataset.viewAllLabel;
        }
      };

      const handleAction = (event) => {
        if (visibleCount >= cards.length) {
          return;
        }

        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }

        event.preventDefault();
        const previousCount = visibleCount;
        visibleCount = Math.min(cards.length, visibleCount + productsPerClick);
        update(previousCount);
      };

      const handleBreakpoint = () => {
        const viewportInitial = mobileQuery.matches ? initialMobile : initialDesktop;
        visibleCount = Math.min(cards.length, Math.max(visibleCount, viewportInitial));
        update(Number.POSITIVE_INFINITY);
      };

      action.addEventListener('click', handleAction);
      mobileQuery.addEventListener('change', handleBreakpoint);
      update(Number.POSITIVE_INFINITY);

      return () => {
        action.removeEventListener('click', handleAction);
        mobileQuery.removeEventListener('change', handleBreakpoint);
      };
    };

    const init = (root) => {
      if (root.dataset.productGridReady === 'true') {
        return;
      }

      root.dataset.productGridReady = 'true';
      root.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-product-swatch]');

        if (swatch && root.contains(swatch)) {
          selectSwatch(swatch);
        }
      });
      root.productGridCleanup = setupProgressiveGrid(root);
    };

    const initAll = () => {
      document.querySelectorAll('[data-nuralea-product-grid]').forEach(init);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-nuralea-product-grid]')
        ? event.target
        : event.target.querySelector('[data-nuralea-product-grid]');

      if (root) {
        init(root);
      }
    });
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches('[data-nuralea-product-grid]')
        ? event.target
        : event.target.querySelector('[data-nuralea-product-grid]');

      if (root && root.productGridCleanup) {
        root.productGridCleanup();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuralea-media-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileViewport = window.matchMedia('(max-width: 749px)');

    const syncMotion = () => {
      document.querySelectorAll('[data-nuralea-media-header] video').forEach((video) => {
        video.defaultMuted = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.controls = false;

        const frame = video.closest('.nuralea-media-header__media-frame');
        const desktopOnly = frame && frame.classList.contains('is-desktop-only');
        const mobileOnly = frame && frame.classList.contains('is-mobile-only');
        const hiddenForViewport = (desktopOnly && mobileViewport.matches) || (mobileOnly && !mobileViewport.matches);

        if (reduceMotion.matches || hiddenForViewport) {
          video.pause();
          return;
        }

        const playback = video.play();
        if (playback && typeof playback.catch === 'function') {
          playback.catch(() => {});
        }
      });
    };

    syncMotion();
    document.addEventListener('shopify:section:load', syncMotion);

    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', syncMotion);
    }

    if (mobileViewport.addEventListener) {
      mobileViewport.addEventListener('change', syncMotion);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuralea-necklaces"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selectSwatch = (swatch) => {
      if (swatch.disabled) {
        return;
      }

      const card = swatch.closest('[data-product-card]');

      if (!card) {
        return;
      }

      card.querySelectorAll('[data-product-swatch]').forEach((item) => {
        const selected = item === swatch;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      if (swatch.dataset.variantUrl) {
        card.querySelectorAll('[data-product-link]').forEach((link) => {
          link.href = swatch.dataset.variantUrl;
        });
      }

      const currentPrice = card.querySelector('[data-current-price]');
      const comparePrice = card.querySelector('[data-compare-price]');
      const saveBadge = card.querySelector('[data-save-badge]');
      const saveValue = card.querySelector('[data-save-value]');
      const isSale = Boolean(swatch.dataset.comparePrice);

      if (currentPrice && swatch.dataset.price) {
        currentPrice.textContent = swatch.dataset.price;
        currentPrice.classList.toggle('is-sale', isSale);
      }

      if (comparePrice) {
        comparePrice.textContent = swatch.dataset.comparePrice || '';
        comparePrice.hidden = !isSale;
      }

      if (saveBadge && saveValue) {
        saveValue.textContent = swatch.dataset.saveValue || '';
        saveBadge.hidden = !swatch.dataset.saveValue;
      }

      if (swatch.dataset.imageSrc) {
        const image = card.querySelector('.nuralea-product-card__image');

        if (image) {
          image.src = swatch.dataset.imageSrc;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.alt = swatch.dataset.imageAlt || image.alt;
        }
      }
    };

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setupProgressiveGrid = (root) => {
      const cards = Array.from(root.querySelectorAll('[data-product-card]'));
      const action = root.querySelector('[data-product-grid-action]');
      const productList = root.querySelector('.nuralea-product-grid__products');

      if (!action || !productList || cards.length === 0) {
        return null;
      }

      const initialMobile = Number.parseInt(root.dataset.initialMobile, 10) || 4;
      const initialDesktop = Number.parseInt(root.dataset.initialDesktop, 10) || 8;
      const productsPerClick = Number.parseInt(root.dataset.productsPerClick, 10) || 4;
      const label = action.querySelector('[data-product-grid-action-label]');
      let visibleCount = Math.min(cards.length, mobileQuery.matches ? initialMobile : initialDesktop);

      action.setAttribute('aria-controls', productList.id);

      const update = (animateFrom) => {
        cards.forEach((card, index) => {
          const shouldHide = index >= visibleCount;
          const shouldAnimate = !shouldHide && index >= animateFrom;
          card.hidden = shouldHide;

          if (shouldAnimate && !reducedMotionQuery.matches) {
            card.classList.remove('is-revealing');
            card.getBoundingClientRect();
            card.classList.add('is-revealing');
            window.setTimeout(() => card.classList.remove('is-revealing'), 500);
          }
        });

        const hasMoreProducts = visibleCount < cards.length;
        action.dataset.actionMode = hasMoreProducts ? 'load-more' : 'view-all';
        action.setAttribute('aria-expanded', hasMoreProducts ? 'false' : 'true');

        if (label) {
          label.textContent = hasMoreProducts
            ? action.dataset.loadMoreLabel
            : action.dataset.viewAllLabel;
        }
      };

      const handleAction = (event) => {
        if (visibleCount >= cards.length) {
          return;
        }

        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }

        event.preventDefault();
        const previousCount = visibleCount;
        visibleCount = Math.min(cards.length, visibleCount + productsPerClick);
        update(previousCount);
      };

      const handleBreakpoint = () => {
        const viewportInitial = mobileQuery.matches ? initialMobile : initialDesktop;
        visibleCount = Math.min(cards.length, Math.max(visibleCount, viewportInitial));
        update(Number.POSITIVE_INFINITY);
      };

      action.addEventListener('click', handleAction);
      mobileQuery.addEventListener('change', handleBreakpoint);
      update(Number.POSITIVE_INFINITY);

      return () => {
        action.removeEventListener('click', handleAction);
        mobileQuery.removeEventListener('change', handleBreakpoint);
      };
    };

    const init = (root) => {
      if (root.dataset.productGridReady === 'true') {
        return;
      }

      root.dataset.productGridReady = 'true';
      root.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-product-swatch]');

        if (swatch && root.contains(swatch)) {
          selectSwatch(swatch);
        }
      });
      root.productGridCleanup = setupProgressiveGrid(root);
    };

    const initAll = () => {
      document.querySelectorAll('[data-nuralea-product-grid]').forEach(init);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-nuralea-product-grid]')
        ? event.target
        : event.target.querySelector('[data-nuralea-product-grid]');

      if (root) {
        init(root);
      }
    });
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches('[data-nuralea-product-grid]')
        ? event.target
        : event.target.querySelector('[data-nuralea-product-grid]');

      if (root && root.productGridCleanup) {
        root.productGridCleanup();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuralea-october-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nuralea-offer-popup')) {
    class NuraleaOfferPopup extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.backdrop = this.querySelector('[data-nop-backdrop]');
        if (!this.dialog || !this.dialog.show) return;
        this.key = 'nuralea:offer:' + (this.dataset.campaign || 'october-2026');
        this.retries = 0;
        const signal = this.controller.signal;
        this.querySelectorAll('[data-nop-close]').forEach(button => button.addEventListener('click', () => this.close(), { signal }));
        document.addEventListener('click', event => {
          if (this.dialog.open && !this.dialog.contains(event.target)) this.close();
        }, { signal });
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !event.defaultPrevented && !event.isComposing && this.dialog.open) {
            event.preventDefault();
            this.close();
          }
        }, { signal });
        this.dialog.addEventListener('close', () => { this.backdrop.hidden = true; }, { signal });
        this.querySelector('[data-nop-copy]').addEventListener('click', () => this.copy(), { signal });
        this.querySelector('[data-nop-claim]').addEventListener('click', event => {
          if (event.currentTarget.hasAttribute('data-nop-claim-copy')) this.copy(true);
          else this.close();
        }, { signal });
        const sectionId = this.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '');
        document.addEventListener('shopify:section:select', event => {
          if (this.dataset.editor === 'true' && this.dataset.editorPreview === 'true' && event.detail?.sectionId === sectionId) this.open(true);
        }, { signal });
        document.addEventListener('shopify:section:deselect', event => {
          if (event.detail?.sectionId === sectionId) this.close();
        }, { signal });
        if (this.dataset.editor === 'true') {
          if (this.dataset.editorPreview === 'true') this.timer = setTimeout(() => this.open(true), 350);
          return;
        }
        if (this.dataset.enabled !== 'true' || this.seen() || this.expired()) return;
        this.timer = setTimeout(() => this.open(), Number(this.dataset.delay || 6) * 1000);
      }
      expired() {
        if (!this.dataset.expires?.trim()) return false;
        const end = Date.parse(this.dataset.expires);
        return !Number.isFinite(end) || Date.now() >= end;
      }
      storage() { return this.dataset.frequency === 'session' ? window.sessionStorage : window.localStorage; }
      seen() {
        try {
          const saved = Number(this.storage().getItem(this.key));
          if (!saved) return false;
          if (this.dataset.frequency === 'session') return true;
          const days = this.dataset.frequency === 'weekly' ? 7 : 1;
          return Date.now() - saved < days * 86400000;
        } catch { return false; }
      }
      remember() {
        if (this.dataset.editor === 'true') return;
        try { this.storage().setItem(this.key, String(Date.now())); } catch {}
      }
      open(preview = false) {
        if (!this.isConnected || this.dialog.open || (!preview && (this.expired() || this.seen()))) return;
        if (!preview && (document.hidden || document.querySelector('dialog[open]') || document.activeElement?.matches('input, textarea, [contenteditable="true"]'))) {
          if (++this.retries < 20) this.timer = setTimeout(() => this.open(), 3000);
          return;
        }
        this.dialog.show();
        this.backdrop.hidden = false;
        this.dialog.focus({ preventScroll: true });
        this.remember();
      }
      close() {
        if (this.dialog?.open) this.dialog.close();
        if (this.backdrop) this.backdrop.hidden = true;
      }
      resetCopyFeedback() {
        this.querySelector('[data-nop-status]').textContent = '';
        const claim = this.querySelector('[data-nop-claim-copy]');
        if (!claim) return;
        claim.removeAttribute('data-copied');
        claim.querySelector('[data-nop-claim-label]').textContent = claim.dataset.label;
      }
      async copy(fromClaim = false) {
        const field = this.querySelector('[data-nop-code]');
        const label = this.querySelector('[data-nop-copy-label]');
        const status = this.querySelector('[data-nop-status]');
        clearTimeout(this.copyTimer);
        this.resetCopyFeedback();
        try {
          await navigator.clipboard.writeText(field.dataset.nopCode);
          if (!this.isConnected) return;
          status.textContent = this.dataset.copied;
          if (fromClaim) {
            const claim = this.querySelector('[data-nop-claim-copy]');
            claim.dataset.copied = 'true';
            claim.querySelector('[data-nop-claim-label]').textContent = this.dataset.claimCopied;
          }
          this.copyTimer = setTimeout(() => this.resetCopyFeedback(), 2500);
        } catch {
          field.focus();
          const range = document.createRange();
          range.selectNodeContents(label);
          const selection = window.getSelection();
          selection?.removeAllRanges();
          selection?.addRange(range);
          status.textContent = this.dataset.manual;
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.copyTimer);
        this.close();
        this.controller?.abort();
        this.controller = undefined;
      }
    }
    customElements.define('nuralea-offer-popup', NuraleaOfferPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuralea-promise-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__nuraleaPromiseBannerLoaded) return;
    window.__nuraleaPromiseBannerLoaded = true;

    const selector = '[data-nuralea-promise-banner]';
    const mobileQuery = window.matchMedia('(max-width: 989px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const init = (root) => {
      if (!root || root.dataset.promiseBannerReady === 'true') return;

      const track = root.querySelector('.nuralea-promise-banner__track');
      const originals = Array.from(root.querySelectorAll('[data-promise-slide]'));
      if (!track || originals.length === 0) return;

      root.dataset.promiseBannerReady = 'true';

      const count = originals.length;
      const autoRotate = root.dataset.autoRotate === 'true';
      const seconds = Number(root.dataset.rotateSeconds);
      const delay = Math.max(4000, (Number.isFinite(seconds) ? seconds : 6) * 1000);
      let currentIndex = 0;
      let timer = null;
      let animating = false;
      let dragging = false;
      let pointerId = null;
      let startX = 0;
      let dragX = 0;
      let slideWidth = 0;

      const makeClone = (source) => {
        const clone = source.cloneNode(true);
        clone.classList.add('is-clone');
        clone.removeAttribute('data-promise-slide');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('role', 'presentation');
        return clone;
      };

      if (count > 1) {
        track.insertBefore(makeClone(originals[count - 1]), originals[0]);
        track.appendChild(makeClone(originals[0]));
        currentIndex = 1;
      }

      const isMobile = () => mobileQuery.matches;

      const activeOriginalIndex = () => {
        if (count === 1) return 0;
        if (currentIndex === 0) return count - 1;
        if (currentIndex === count + 1) return 0;
        return currentIndex - 1;
      };

      const updateAccessibility = () => {
        originals.forEach((slide, index) => {
          if (isMobile()) {
            slide.setAttribute('aria-hidden', index === activeOriginalIndex() ? 'false' : 'true');
          } else {
            slide.removeAttribute('aria-hidden');
          }
        });
      };

      const setPosition = (animate) => {
        if (!animate) track.classList.add('is-jumping');
        track.style.transform = `translate3d(${-currentIndex * 100}%, 0, 0)`;
        updateAccessibility();

        if (!animate) {
          track.getBoundingClientRect();
          requestAnimationFrame(() => track.classList.remove('is-jumping'));
        }
      };

      const stopTimer = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const move = (direction) => {
        if (!isMobile() || count < 2 || animating || dragging) return;
        currentIndex += direction;
        animating = true;
        setPosition(true);
      };

      const startTimer = () => {
        stopTimer();
        if (!autoRotate || !isMobile() || count < 2 || reducedMotionQuery.matches || document.hidden) return;
        timer = window.setInterval(() => move(1), delay);
      };

      const handleTransitionEnd = (event) => {
        if (event.target !== track || event.propertyName !== 'transform') return;
        animating = false;

        if (currentIndex === 0) {
          currentIndex = count;
          setPosition(false);
        } else if (currentIndex === count + 1) {
          currentIndex = 1;
          setPosition(false);
        }
      };

      const handlePointerDown = (event) => {
        if (!isMobile() || count < 2 || animating || event.button > 0) return;
        dragging = true;
        pointerId = event.pointerId;
        startX = event.clientX;
        dragX = 0;
        slideWidth = root.getBoundingClientRect().width;
        track.classList.add('is-dragging');
        stopTimer();
        if (track.setPointerCapture) track.setPointerCapture(pointerId);
      };

      const handlePointerMove = (event) => {
        if (!dragging || event.pointerId !== pointerId) return;
        dragX = event.clientX - startX;
        track.style.transform = `translate3d(${(-currentIndex * slideWidth) + dragX}px, 0, 0)`;
      };

      const finishDrag = (event, cancelled) => {
        if (!dragging || event.pointerId !== pointerId) return;

        dragging = false;
        track.classList.remove('is-dragging');
        if (track.hasPointerCapture && track.hasPointerCapture(pointerId)) {
          track.releasePointerCapture(pointerId);
        }

        const threshold = Math.min(72, Math.max(38, slideWidth * 0.14));
        if (!cancelled && Math.abs(dragX) >= threshold) {
          currentIndex += dragX < 0 ? 1 : -1;
          animating = true;
        }

        pointerId = null;
        setPosition(true);
        startTimer();
      };

      const handleViewportChange = () => {
        dragging = false;
        animating = false;
        track.classList.remove('is-dragging');
        setPosition(false);
        startTimer();
      };

      const handleVisibilityChange = () => {
        if (document.hidden) stopTimer();
        else startTimer();
      };

      const handleBlockSelect = (event) => {
        const block = event.target.closest ? event.target.closest('[data-promise-slide]') : null;
        const selectedIndex = originals.indexOf(block);
        if (selectedIndex < 0) return;

        currentIndex = count > 1 ? selectedIndex + 1 : 0;
        animating = false;
        setPosition(false);
        stopTimer();
      };

      const handleBlockDeselect = () => startTimer();

      track.addEventListener('transitionend', handleTransitionEnd);
      track.addEventListener('pointerdown', handlePointerDown);
      track.addEventListener('pointermove', handlePointerMove);
      track.addEventListener('pointerup', (event) => finishDrag(event, false));
      track.addEventListener('pointercancel', (event) => finishDrag(event, true));
      mobileQuery.addEventListener('change', handleViewportChange);
      reducedMotionQuery.addEventListener('change', startTimer);
      document.addEventListener('visibilitychange', handleVisibilityChange);
      root.addEventListener('shopify:block:select', handleBlockSelect);
      root.addEventListener('shopify:block:deselect', handleBlockDeselect);

      setPosition(false);
      startTimer();

      root.nuraleaPromiseBannerCleanup = () => {
        stopTimer();
        mobileQuery.removeEventListener('change', handleViewportChange);
        reducedMotionQuery.removeEventListener('change', startTimer);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
    };

    const initWithin = (container) => {
      if (container.matches && container.matches(selector)) init(container);
      if (container.querySelectorAll) container.querySelectorAll(selector).forEach(init);
    };

    const boot = () => initWithin(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches && event.target.matches(selector)
        ? event.target
        : event.target.querySelector && event.target.querySelector(selector);
      if (root && root.nuraleaPromiseBannerCleanup) root.nuraleaPromiseBannerCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuralea-rings"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selectSwatch = (swatch) => {
      if (swatch.disabled) {
        return;
      }

      const card = swatch.closest('[data-product-card]');

      if (!card) {
        return;
      }

      card.querySelectorAll('[data-product-swatch]').forEach((item) => {
        const selected = item === swatch;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      if (swatch.dataset.variantUrl) {
        card.querySelectorAll('[data-product-link]').forEach((link) => {
          link.href = swatch.dataset.variantUrl;
        });
      }

      const currentPrice = card.querySelector('[data-current-price]');
      const comparePrice = card.querySelector('[data-compare-price]');
      const saveBadge = card.querySelector('[data-save-badge]');
      const saveValue = card.querySelector('[data-save-value]');
      const isSale = Boolean(swatch.dataset.comparePrice);

      if (currentPrice && swatch.dataset.price) {
        currentPrice.textContent = swatch.dataset.price;
        currentPrice.classList.toggle('is-sale', isSale);
      }

      if (comparePrice) {
        comparePrice.textContent = swatch.dataset.comparePrice || '';
        comparePrice.hidden = !isSale;
      }

      if (saveBadge && saveValue) {
        saveValue.textContent = swatch.dataset.saveValue || '';
        saveBadge.hidden = !swatch.dataset.saveValue;
      }

      if (swatch.dataset.imageSrc) {
        const image = card.querySelector('.nuralea-product-card__image');

        if (image) {
          image.src = swatch.dataset.imageSrc;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.alt = swatch.dataset.imageAlt || image.alt;
        }
      }
    };

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setupProgressiveGrid = (root) => {
      const cards = Array.from(root.querySelectorAll('[data-product-card]'));
      const action = root.querySelector('[data-product-grid-action]');
      const productList = root.querySelector('.nuralea-product-grid__products');

      if (!action || !productList || cards.length === 0) {
        return null;
      }

      const initialMobile = Number.parseInt(root.dataset.initialMobile, 10) || 4;
      const initialDesktop = Number.parseInt(root.dataset.initialDesktop, 10) || 8;
      const productsPerClick = Number.parseInt(root.dataset.productsPerClick, 10) || 4;
      const label = action.querySelector('[data-product-grid-action-label]');
      let visibleCount = Math.min(cards.length, mobileQuery.matches ? initialMobile : initialDesktop);

      action.setAttribute('aria-controls', productList.id);

      const update = (animateFrom) => {
        cards.forEach((card, index) => {
          const shouldHide = index >= visibleCount;
          const shouldAnimate = !shouldHide && index >= animateFrom;
          card.hidden = shouldHide;

          if (shouldAnimate && !reducedMotionQuery.matches) {
            card.classList.remove('is-revealing');
            card.getBoundingClientRect();
            card.classList.add('is-revealing');
            window.setTimeout(() => card.classList.remove('is-revealing'), 500);
          }
        });

        const hasMoreProducts = visibleCount < cards.length;
        action.dataset.actionMode = hasMoreProducts ? 'load-more' : 'view-all';
        action.setAttribute('aria-expanded', hasMoreProducts ? 'false' : 'true');

        if (label) {
          label.textContent = hasMoreProducts
            ? action.dataset.loadMoreLabel
            : action.dataset.viewAllLabel;
        }
      };

      const handleAction = (event) => {
        if (visibleCount >= cards.length) {
          return;
        }

        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }

        event.preventDefault();
        const previousCount = visibleCount;
        visibleCount = Math.min(cards.length, visibleCount + productsPerClick);
        update(previousCount);
      };

      const handleBreakpoint = () => {
        const viewportInitial = mobileQuery.matches ? initialMobile : initialDesktop;
        visibleCount = Math.min(cards.length, Math.max(visibleCount, viewportInitial));
        update(Number.POSITIVE_INFINITY);
      };

      action.addEventListener('click', handleAction);
      mobileQuery.addEventListener('change', handleBreakpoint);
      update(Number.POSITIVE_INFINITY);

      return () => {
        action.removeEventListener('click', handleAction);
        mobileQuery.removeEventListener('change', handleBreakpoint);
      };
    };

    const init = (root) => {
      if (root.dataset.productGridReady === 'true') {
        return;
      }

      root.dataset.productGridReady = 'true';
      root.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-product-swatch]');

        if (swatch && root.contains(swatch)) {
          selectSwatch(swatch);
        }
      });
      root.productGridCleanup = setupProgressiveGrid(root);
    };

    const initAll = () => {
      document.querySelectorAll('[data-nuralea-product-grid]').forEach(init);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-nuralea-product-grid]')
        ? event.target
        : event.target.querySelector('[data-nuralea-product-grid]');

      if (root) {
        init(root);
      }
    });
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches('[data-nuralea-product-grid]')
        ? event.target
        : event.target.querySelector('[data-nuralea-product-grid]');

      if (root && root.productGridCleanup) {
        root.productGridCleanup();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuralea-sommer-sale-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const countdownTimers = new WeakMap();
    const sliderTimers = new WeakMap();

    const getBenefits = (root) => {
      const owner = root.dataset.sectionId;
      return document.querySelector(`[data-nuralea-benefits][data-owner="${owner}"]`);
    };

    const findHeader = (root) => {
      const selectors = [
        '#shopify-section-header',
        '.shopify-section-header',
        'sticky-header',
        'header[role="banner"]',
        'header'
      ];

      for (const selector of selectors) {
        const element = document.querySelector(selector);
        if (element && !root.contains(element)) {
          return element.closest('.shopify-section') || element;
        }
      }

      return null;
    };

    const placeBenefits = (root) => {
      const benefits = getBenefits(root);
      const anchor = root.querySelector('[data-benefits-anchor]');

      if (!benefits || !anchor) {
        return;
      }

      const shouldMove = root.dataset.mobileBelowHeader === 'true' && mobileQuery.matches;

      if (shouldMove) {
        const header = findHeader(root);

        if (header && header.nextElementSibling !== benefits) {
          header.insertAdjacentElement('afterend', benefits);
        }

        benefits.classList.add('is-mobile-placed');
        return;
      }

      if (benefits.parentElement !== root) {
        anchor.insertAdjacentElement('afterend', benefits);
      }

      benefits.classList.remove('is-mobile-placed');
    };

    const pad = (value) => String(value).padStart(2, '0');

    const getRollingEnd = (root) => {
      const hours = Math.max(1, Number.parseInt(root.dataset.rollingHours, 10) || 24);
      const storageKey = `nuraleaSaleBarEnd:${root.dataset.sectionId}:${hours}`;
      let end = 0;

      try {
        end = Number.parseInt(window.localStorage.getItem(storageKey), 10) || 0;
      } catch (error) {
        end = 0;
      }

      if (!end || end <= Date.now()) {
        end = Date.now() + hours * 60 * 60 * 1000;

        try {
          window.localStorage.setItem(storageKey, String(end));
        } catch (error) {
          return end;
        }
      }

      return end;
    };

    const getCountdownEnd = (root, countdown) => {
      if (root.dataset.countdownMode === 'deadline') {
        const deadline = Date.parse(countdown.dataset.countdownEnd);

        if (!Number.isNaN(deadline)) {
          return deadline;
        }
      }

      return getRollingEnd(root);
    };

    const startCountdown = (root) => {
      const countdown = root.querySelector('[data-nuralea-countdown]');
      const timer = root.querySelector('[data-countdown-timer]');

      if (!countdown || !timer) {
        return;
      }

      const hoursNode = timer.querySelector('[data-countdown-hours]');
      const minutesNode = timer.querySelector('[data-countdown-minutes]');
      const secondsNode = timer.querySelector('[data-countdown-seconds]');

      if (!hoursNode || !minutesNode || !secondsNode) {
        return;
      }

      window.clearInterval(countdownTimers.get(root));

      let end = getCountdownEnd(root, countdown);

      const render = () => {
        if (root.dataset.countdownMode !== 'deadline' && end <= Date.now()) {
          end = getRollingEnd(root);
        }

        const remaining = Math.max(0, end - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        hoursNode.textContent = pad(hours);
        minutesNode.textContent = pad(minutes);
        secondsNode.textContent = pad(seconds);

        if (timer.dataset.countdownLabelTemplate) {
          timer.setAttribute(
            'aria-label',
            timer.dataset.countdownLabelTemplate
              .replace('{hours}', hours)
              .replace('{minutes}', minutes)
              .replace('{seconds}', seconds)
          );
        }
      };

      render();
      countdownTimers.set(root, window.setInterval(render, 1000));
    };

    const setupSlider = (root) => {
      const benefits = getBenefits(root);

      if (!benefits || benefits.dataset.sliderReady === 'true') {
        return;
      }

      benefits.dataset.sliderReady = 'true';

      const items = Array.from(benefits.querySelectorAll('[data-benefit-item]'));

      if (items.length <= 1) {
        return;
      }

      let activeIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));

      const activate = (index) => {
        activeIndex = (index + items.length) % items.length;
        items.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === activeIndex);
        });
      };

      const previous = benefits.querySelector('[data-benefit-prev]');
      const next = benefits.querySelector('[data-benefit-next]');

      if (previous) {
        previous.addEventListener('click', () => activate(activeIndex - 1));
      }

      if (next) {
        next.addEventListener('click', () => activate(activeIndex + 1));
      }

      window.clearInterval(sliderTimers.get(benefits));
      sliderTimers.set(benefits, window.setInterval(() => {
        if (mobileQuery.matches && !document.hidden) {
          activate(activeIndex + 1);
        }
      }, 4500));
    };

    const init = (root) => {
      if (root.dataset.saleBarReady === 'true') {
        placeBenefits(root);
        return;
      }

      root.dataset.saleBarReady = 'true';
      startCountdown(root);
      setupSlider(root);
      placeBenefits(root);
    };

    const initAll = () => {
      document.querySelectorAll('[data-nuralea-sale-bar]').forEach(init);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-nuralea-sale-bar]').forEach(init);
    });
    window.addEventListener('resize', initAll, { passive: true });

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', initAll);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
